// extracted by mini-css-extract-plugin
export default {"timeLearn__item":"ItemLearn_timeLearn__item__6r9c1"};